// extracted by mini-css-extract-plugin
export default {"userManagement":"UserManagement_userManagement__JWSUo","tabContainer":"UserManagement_tabContainer__Kqnqh","invitations":"UserManagement_invitations__H7CYc"};